import { LanguageFlagsUrls } from '@config/language-flags.config';

export interface KioskLanguageFlagOption {
  locale: string;
  flagUrl?: string;
}

export const KIOSK_SPLASH_CTA_OVERLAY_BASE_CLASSES =
  'text-primary fixed bottom-0 left-0 right-0 flex flex-col items-center justify-center gap-10 px-10 pt-20 text-center';

export const KIOSK_SPLASH_CTA_OVERLAY_WITH_FLAGS_CLASSES = 'min-h-400px pb-14.5';
export const KIOSK_SPLASH_CTA_OVERLAY_WITHOUT_FLAGS_CLASSES = 'pb-20';

export function shouldDisplayKioskLanguageFlags(
  locales: ReadonlyArray<{ locale: string }> | null | undefined,
): boolean {
  return (locales?.length ?? 0) > 1;
}

export function mapKioskLanguageFlags(
  locales: ReadonlyArray<{ locale: string }> | null | undefined,
): KioskLanguageFlagOption[] {
  if (!shouldDisplayKioskLanguageFlags(locales)) {
    return [];
  }

  return locales!.map(language => ({
    locale: language.locale,
    flagUrl: LanguageFlagsUrls.get(language.locale),
  }));
}

/** Overlay classes: keep room for flags, compact the CTA bar otherwise. */
export function kioskSplashCtaOverlayClassList(hasLanguageFlags: boolean): string {
  const spacing = hasLanguageFlags
    ? KIOSK_SPLASH_CTA_OVERLAY_WITH_FLAGS_CLASSES
    : KIOSK_SPLASH_CTA_OVERLAY_WITHOUT_FLAGS_CLASSES;

  return `${KIOSK_SPLASH_CTA_OVERLAY_BASE_CLASSES} ${spacing}`;
}
